<script setup>

</script>

<template>
  <button class="p-2 px-4 rounded-md bg-blue-800 text-white font-open-sans hover:scale-105 transition-transform w-fit">
    <slot></slot>
  </button>
</template>

<style scoped>

</style>